<template>
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.251953 0.5H1.97789V2.70669C3.00483 1.89974 4.29979 1.41846 5.70715 1.41846C9.04338 1.41846 11.7479 4.123 11.7479 7.45923C11.7479 10.7955 9.04338 13.5 5.70715 13.5C3.85135 13.5 2.19101 12.6632 1.0829 11.3462L2.48032 10.3238C3.27071 11.2135 4.42347 11.7741 5.70715 11.7741C8.09017 11.7741 10.022 9.84225 10.022 7.45923C10.022 5.07621 8.09017 3.14439 5.70715 3.14439C4.76924 3.14439 3.90123 3.44364 3.19337 3.95187L5.42976 3.95187V5.6778H0.251953V0.5Z"
      fill="#E87070"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
